import { isEmpty } from 'lodash';
import {
	CreateVestingTermGradedDto,
	UpdateVestingTermGradedDto,
	VestingTermGradedRes,
} from '@dealstack/shared/lib/generated';

import { GradedTerm } from './GradedTerm/GradedTerm';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { getRemainingVestingPercentage } from '@dealstack/frontend/shared/components/VestingTerms/helpers/vesting-percent.ts';
import { Button } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';

interface Props {
	vestingTermId: string;
	vestingTermGraded: VestingTermGradedRes[];
	gradedTermCreatorOpen: boolean;
	setGradedTermCreatorOpen: (bool: boolean) => void;
	onCreateVestingTermGraded: (vestingFormGraded: CreateVestingTermGradedDto) => void;
	onUpdateVestingTermGraded: (
		gradedTermId: string,
		formValues: UpdateVestingTermGradedDto
	) => void;
	onDeleteVestingTermGraded: (gradedTermId: string) => void;
}

export const GradedTerms = ({
	vestingTermId,
	vestingTermGraded,
	gradedTermCreatorOpen,
	setGradedTermCreatorOpen,
	onCreateVestingTermGraded,
	onUpdateVestingTermGraded,
	onDeleteVestingTermGraded,
}: Props) => {
	const tCommonUi = useTranslationCommonUi();

	const remainingPercentage = getRemainingVestingPercentage(vestingTermGraded);

	return (
		<>
			{vestingTermGraded.map((gradedTerm) => (
				<div key={gradedTerm.id} className="mb-2">
					<GradedTerm
						vestingTermId={vestingTermId}
						vestingTermGraded={gradedTerm}
						remainingPercentage={remainingPercentage}
						setGradedTermCreatorOpen={setGradedTermCreatorOpen}
						onCreateVestingTermGraded={onCreateVestingTermGraded}
						onUpdateVestingTermGraded={onUpdateVestingTermGraded}
						onDeleteVestingTermGraded={onDeleteVestingTermGraded}
					/>
				</div>
			))}
			{gradedTermCreatorOpen ? (
				<div key="graded_term_creator" className="mb-2">
					<GradedTerm
						vestingTermId={vestingTermId}
						gradedTermCreatorOpen={gradedTermCreatorOpen}
						remainingPercentage={remainingPercentage}
						setGradedTermCreatorOpen={setGradedTermCreatorOpen}
						onCreateVestingTermGraded={onCreateVestingTermGraded}
						onUpdateVestingTermGraded={onUpdateVestingTermGraded}
						onDeleteVestingTermGraded={onDeleteVestingTermGraded}
					/>
				</div>
			) : (
				remainingPercentage !== 0 && (
					<Button
						onClick={() => setGradedTermCreatorOpen(true)}
						variant="ghost"
						leftSection={<Icon variant="plus" size="lg" />}
					>
						{tCommonUi(
							!isEmpty(vestingTermGraded)
								? 'vesting_terms.add_another_graded_vesting_term'
								: 'vesting_terms.add_graded_vesting_term',
							{ remainingPercentage }
						)}
					</Button>
				)
			)}
		</>
	);
};
